<div class="w-full">
  <mat-dialog-content>
    <h2 mat-dialog-title>{{ title | translate }}</h2>
    <form [formGroup]="form" class="">
      @for (input of config.inputs; track input; let i = $index) {
        <mat-form-field class="w-full" appearance="fill">
          <mat-label>{{ input.label | translate }}</mat-label>
          <input matInput [formControl]="controls[input.controlName]" placeholder="{{ input.placeholder | translate }}">
        </mat-form-field>
      }
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="w-full flex justify-between">
    <button mat-flat-button mat-dialog-close class="flex-grow bg-tw-disabled">{{ 'CANCEL' | translate }}</button>
    <button mat-flat-button [mat-dialog-close]="true" class="flex-grow bg-tw-primary text-tw-text-light" [disabled]="!isValid" (click)="submit()">{{ valid | translate }}</button>
  </mat-dialog-actions>
</div>